export enum TutorialsMutations {
    SET_VIEW = 'SET_VIEW',
}
